import { httpApi } from './http.api';
import type {
  CheckMonitorPeriod,
  CheckMonitorResponse,
} from 'types/checkMonitor';

export interface CheckMonitorQuery {
  period: CheckMonitorPeriod;
  anchor?: string;
  timeZone?: string;
}

export const getCheckMonitor = async (
  params: CheckMonitorQuery,
  signal: AbortSignal
): Promise<CheckMonitorResponse> => {
  const response = await httpApi.get<CheckMonitorResponse>(
    'checker/check-monitor',
    {
      params,
      signal,
    }
  );
  return response.data;
};
